import { Color } from '@billy/design-system'
import styled from '@emotion/styled'

import { DotToCheckmarkSize } from './types'

interface DotToCheckmarkContainerProps {
  isUpcoming?: boolean
  size: DotToCheckmarkSize
}

const SIZE_VARIANTS = {
  s: {
    container: '20px',
    dot: '8px',
    checkmark: '16px',
  },
  m: {
    container: '40px',
    dot: '16px',
    checkmark: '32px',
  },
  l: {
    container: '40px',
    dot: '16px',
    checkmark: '32px',
  },
} as const

export const DotToCheckmarkContainer = styled.div<DotToCheckmarkContainerProps>`
  display: inline-block;
  width: ${({ size }) => SIZE_VARIANTS[size].container};
  height: ${({ size }) => SIZE_VARIANTS[size].container};
  border-radius: 50%;
  position: relative;
  background: ${({ isUpcoming }) => (isUpcoming ? Color.Grey200 : Color.Black)};
  cursor: pointer;
  transition: transform 0.3s ease;
`

interface DotProps {
  isAnimating?: boolean
  isSuccess?: boolean
  isUpcoming?: boolean
  size: DotToCheckmarkSize
}

export const Dot = styled.span<DotProps>`
  opacity: ${({ isSuccess, isAnimating }) => (isSuccess || isAnimating ? 0 : 1)};
  width: ${({ size }) => SIZE_VARIANTS[size].dot};
  height: ${({ size }) => SIZE_VARIANTS[size].dot};
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%)
    ${({ isSuccess, isAnimating }) => (isSuccess || isAnimating ? 'scale(0)' : 'scale(1)')};
  background: ${({ isUpcoming }) => (isUpcoming ? Color.Grey200 : Color.Lavender500)};
  transition: all 0.3s ease-out;
`

interface CheckmarkProps {
  size: DotToCheckmarkSize
}

export const Checkmark = styled.svg<CheckmarkProps>`
  width: ${({ size }) => SIZE_VARIANTS[size].checkmark};
  height: ${({ size }) => SIZE_VARIANTS[size].checkmark};
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`

export const LineShort = styled.line<{ isAnimating: boolean }>`
  transition: ${({ isAnimating }) =>
    isAnimating ? 'stroke-dashoffset 0.4s ease-out 0.4s' : 'stroke-dashoffset 0.3s ease-out'};
`

export const LineLong = styled.line<{ isAnimating: boolean }>`
  transition: ${({ isAnimating }) =>
    isAnimating ? 'stroke-dashoffset 1s ease-out 0.45s' : 'stroke-dashoffset 0.3s ease-out'};
`
